/** @format */

/** Build-time app version from package.json, injected by Vite define. */
declare const __APP_VERSION__: string;

/** The application version string (e.g. "2026.02.23.3"). */
export const APP_VERSION: string = __APP_VERSION__;

/** IndexedDB/react-query cache schema version (bump only for cache-shape changes). */
export const QUERY_CACHE_SCHEMA_VERSION = 2;

/** Browser event emitted when a waiting service worker update is detected. */
export const SW_UPDATE_AVAILABLE_EVENT = "galaxie:sw-update-available";
